import { IPhxAxTitleAnnouncerDelegate, IStickyState, IConsistentRouteConfigurationProvider } from '../types';
angular
  .module('capability-ng-global')
  .config(function(
    ConsistentRouteConfigurationProvider: IConsistentRouteConfigurationProvider,
    $locationProvider: ng.ILocationProvider
  ) {
    $locationProvider.hashPrefix('!');

    ConsistentRouteConfigurationProvider.activate({
      faultRoute: '/oops/'
    });
  })
  .run(function(
    $rootScope: ng.IRootScopeService,
    log: any,
    $stickyState: IStickyState,
    phxAxTitleAnnouncerDelegate: IPhxAxTitleAnnouncerDelegate
  ) {
    $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) =>
      log.system.info('state change error', toState.name, JSON.stringify(error))
    );

    $rootScope.$on('$stateNotFound', (event, unFoundState, fromState, fromParams) =>
      log.system.info('state not found', unFoundState.to + '')
    );

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) =>
      log.system.info('state change started', toState.name + '')
    );

    $rootScope.$on('$stateChangeSuccess', (event, toState, fromState, fromParams) => {
      if (!toState.name.includes('modal')) {
        $stickyState.reset('*');
      }

      if (toState.data && toState.data.viewTitle) {
        phxAxTitleAnnouncerDelegate.setTitle(toState.data.viewTitle);
      }
    });
  });



// WEBPACK FOOTER //
// ./app/lib/global/configuration/routing.ts